export { default as DetailRecordPage } from "./detailsRecord";
